import { Api } from '../services/Api';

export class Environment {
  api: Api;

  constructor() {
    this.api = new Api();
  }
}
